<div class="p-3 flex flex-column flex-grow-1">
  <h2>{{ 'LABELS.LICENSES' | translate }}</h2>
  <div class="flex align-items-end">
    <div class="flex align-items-end gap-3 flex-1">
      <div class="w-3">
        <label class="block mb-2 ios-font-875 text-color-secondary">{{ 'LABEL.SEARCH' | translate }}</label>
        <input class="w-full pt-3 pl-3 pb-3" type="text" pInputText [formControl]="search" [placeholder]="'LABELS.SEARCH' | translate" />
      </div>

      <p-selectButton
        class="ios-select-button"
        [options]="options"
        [(ngModel)]="expiredOnly"
        optionValue="value"
        (ngModelChange)="changeLicenseState()"
      >
        <ng-template let-item pTemplate>
          <span>{{ item.label | translate }}</span>
        </ng-template>
      </p-selectButton>
    </div>

    <button pButton [label]="'BUTTONS.ACTIVATE_OFFLINE_LICENSE' | translate" (click)="openActivationDialog()"></button>
  </div>

  <div class="mt-3 h-full flex flex-column flex-grow-1" *ngIf="!loading">
    <app-licenses-list [dataSource]="dataSource" (onSort)="changeSort($event)"></app-licenses-list>
  </div>

  <ng-container *ngIf="loading">
    <div class="flex flex-column flex-grow-1 align-items-center justify-content-center">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </ng-container>
</div>
